import { render, staticRenderFns } from "./BranchInformation.vue?vue&type=template&id=f9c3c70a&scoped=true"
import script from "./BranchInformation.vue?vue&type=script&lang=js"
export * from "./BranchInformation.vue?vue&type=script&lang=js"
import style0 from "./BranchInformation.vue?vue&type=style&index=0&id=f9c3c70a&prod&lang=css"
import style1 from "./BranchInformation.vue?vue&type=style&index=1&id=f9c3c70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c3c70a",
  null
  
)

export default component.exports